import React, { useEffect, useState } from "react";
import "./shoppingCart.scss";
import emprtyCart from "../../images/cart/empty-cart.jpg";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CartBlock from "../../components/Cart_block/CartBlock";
import { clearCart } from "../../containers/rtk/slices/slice";
const ShoppingCart = () => {
  // handle loader
  const [loader, showloader] = useState(false);
  const showloaderr = () => {
    showloader(true);
    setTimeout(() => {
      showloader(false);
    }, 1200);
    window.scrollTo(0, 0);
  };
  // call cart items
  const carts = useSelector((state) => state.cart);
  // handle what to show
  const [empty, isemty] = useState(false);
  const [items, showitems] = useState(false);
  const handlecontent = () => {
    if (carts.length > 0) {
      isemty(false);
      showitems(true);
    } else {
      isemty(true);
      showitems(false);
    }
  };
  const dispatch = useDispatch();

  useEffect(() => {
    handlecontent();
    gettotal();
  });

  // get sum
  const [totalsum, settotalsum] = useState(0);
  const gettotal = () => {
    let sum = 0;
    let allprices = document.querySelectorAll(".cart_block .price span");
    allprices.forEach((element) => {
      sum += Number(element.innerText);
      settotalsum(sum);
    });
  };

  return (
    <>
      {/* start loader */}
      {loader && (
        <div className="mainloader">
          <span className="Circleloader"></span>
        </div>
      )}
      <div className="shoppingCart">
        <div className="container">
          <h2>Shopping Cart</h2>
          <p>
            <a href="home">Home Page </a>/ Clothing Categories / Shopping Cart
          </p>
          <div className="shoppingCart_container">
            <div className="row">
              {items && (
                <div className="cartItems col-lg-8 col-md-6 col-sm-12">
                  {carts.map((item) => {
                    return (
                      <CartBlock
                        key={item.id}
                        name={item.name.slice(0, 30)}
                        img={item.img}
                        price={item.price.slice(0, 2)}
                        quantity={item.quantity}
                        itemdetails={item}
                      />
                    );
                  })}
                  <div className="cartbtns">
                    <button
                      className="clearall"
                      onClick={() => dispatch(clearCart())}
                    >
                      Clear ALL
                    </button>

                    <Link
                      to="/OurStore"
                      className="continueshop"
                      onClick={() => showloaderr()}
                    >
                      Continue Shopping
                    </Link>
                    <button onClick={() => gettotal()} className="get_reset">
                      Get Reset
                    </button>
                  </div>
                </div>
              )}
              {empty && (
                <div className="emptycart col-lg-8 col-md-6 col-sm-12">
                  <img src={emprtyCart} alt="emprtyCart"></img>
                  <p> Cart is Empty </p>
                  <Link to="/OurStore" href="#" onClick={() => showloaderr()}>
                    Start Shopping
                  </Link>
                </div>
              )}

              <div className="summary col-lg-4 col-md-6 col-sm-12">
                <h2>Order Summary</h2>
                <div className="subtotal">
                  <span>Subtotal</span>
                  <small>${totalsum}</small>
                </div>

                <div className="Shpping">
                  <span>Shpping estimate</span>
                  <small>$12.00</small>
                </div>

                <div className="Tax">
                  <span>Tax estimate</span>
                  <small>$4.00</small>
                </div>

                <div className="order_total">
                  <span style={{ color: "#0F172A", fontWeight: "700" }}>
                    Order total
                  </span>
                  <small>${totalsum + 12.0 + 4.0}</small>
                </div>
                <Link
                  to="/Account"
                  className="checkout"
                  onClick={() => showloaderr()}
                >
                  Checkout
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShoppingCart;
